import React from 'react';
import { X, FileText, FileCode, FileJson, Table, Image, Loader2 } from 'lucide-react';
import styles from '../../styles/FileUpload.module.css';

const getFileIcon = (fileName) => {
  const ext = fileName.split('.').pop().toLowerCase();
  
  // Code files
  if (['py', 'js', 'java', 'cpp', 'html', 'css', 'md'].includes(ext)) {
    return <FileCode size={16} />;
  }
  // Data files
  if (['csv', 'tsv', 'json', 'xml'].includes(ext)) {
    return <FileJson size={16} />;
  }
  // Image files (if we add support later)
  if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(ext)) {
    return <Image size={16} />;
  }
  // Table files
  if (['csv', 'tsv'].includes(ext)) {
    return <Table size={16} />;
  }
  // Default document icon
  return <FileText size={16} />;
};

const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export default function FileChip({ file, fileId, onRemove, status = 'uploaded', progress = 0 }) {
  const isUploading = status === 'uploading';
  const isError = status === 'error';
  const isProcessing = status === 'processing';

  // Helper function to get status text
  const getStatusText = () => {
    if (isUploading) {
      return `Uploading... ${Math.round(progress)}%`;
    }
    if (isProcessing) {
      return 'Processing...';
    }
    if (isError) {
      return 'Upload failed';
    }
    return formatFileSize(file.size);
  };

  return (
    <div className={`${styles.fileChip} ${styles[status]}`}>
      <div className={styles.fileChipContent}>
        <span className={styles.fileIcon}>
          {/* Show a loading spinner when uploading or processing */}
          {(isUploading || isProcessing) ? (
            <Loader2 size={16} className={styles.spinningIcon} />
          ) : (
            getFileIcon(file.name)
          )}
        </span>
        <div className={styles.fileInfo}>
          <span className={styles.fileName}>{file.name}</span>
          <span className={`${styles.fileSize} ${isError ? styles.errorText : ''}`}>
            {getStatusText()}
          </span>
        </div>
        {!isUploading && !isProcessing && (
          <button
            type="button"
            onClick={() => onRemove(fileId)}
            className={styles.removeButton}
            title="Remove file"
          >
            <X size={14} />
          </button>
        )}
      </div>
      
      {/* Only show progress bar when uploading */}
      {isUploading && (
        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
}